<script setup>
import GererForm from '@/components/GererForm.vue'
import roleCheckMixin from "@/mixins/roleCheckMixin";
</script>

<template>
  <h1>Gérer les espaces utilisateurs</h1>
  <div class="gerer container">
    <GererForm />
  </div>
</template>

<script>
 
export default {
    mixins: [roleCheckMixin],
 }
</script>

<style>
@media (min-width: 1024px) {
  .about {
    min-height: 100vh;
    display: flex;
    align-items: center;
  }
}
</style>
